import _axios, { AxiosInstance } from 'axios';
import { baseURL } from '@utils/common';

export const accaResultAxios: AxiosInstance = _axios.create({ baseURL });
